import axios from 'axios';
import { port } from '../constants/constants';

const BASE = `${port}/api/partstech`;

// partTypeIds: string[] — PartsTech part type IDs (e.g. ["5340"] for brake pads)
// vehicleId: string    — PartsTech internal vehicle ID (obtained from their vehicle lookup)
// vin: string          — VIN, used alongside or instead of vehicleId
// keyword: string      — free-text search
// partNumber: string   — specific part number lookup
export async function searchPartsTech({ partTypeIds, vehicleId, vin, plate, year, make, model, engine, keyword, partNumber } = {}) {
    const res = await axios.post(`${BASE}/search`, {
        partTypeIds, vehicleId, vin,
        plate,   // { plate: "44670MG", state: "NY" }
        year, make, model, engine,
        keyword, partNumber,
    });
    return res.data; // { distributors: [{ supplier, products: [...] }] }
}

export async function getTypeahead(search) {
    const res = await axios.get(`${BASE}/typeahead`, { params: { search } });
    return res.data; // [{ id, name, suggested, isPartNumber?, brand? }]
}

export async function getCart() {
    const res = await axios.get(`${BASE}/cart`);
    return res.data;
}

export async function addToCart({ partNumberId, partNumber, lineCardId, accountId, storeId, quantity, partName, vehicleId, vin }) {
    const res = await axios.post(`${BASE}/cart/add`, { partNumberId, partNumber, lineCardId, accountId, storeId, quantity, partName, vehicleId, vin });
    return res.data;
}

export async function removeFromCart(itemIds) {
    const res = await axios.post(`${BASE}/cart/remove`, { itemIds });
    return res.data;
}

export async function updateCartQuantity(itemId, quantity) {
    const res = await axios.post(`${BASE}/cart/quantity`, { itemId, quantity });
    return res.data;
}

export async function buyCart(orders) {
    const res = await axios.post(`${BASE}/cart/buy`, { orders });
    return res.data;
}
